// localStorage.setItem('preCart', JSON.stringify(LocalStoragePreCart));

	window.addEventListener('DOMContentLoaded', function() {    
		$(document).ready(function() {
			wishlistCollectionPage();
		});    
	})
	function wishlistCollectionPage() {
			$( ".buttons__collection-wishlist-not-login" ).on( "click", function(e) {

				let productTitle = $(this).attr("data-title");
        		localStorage.setItem('swym-login-analitics', productTitle);


        	let variantID = $(this).attr("data-variant-id");
					let variantTitle = $(this).attr("data-variant-title");					
					let variantPrice = $(this).attr('data-variant-price');

					let productID = $(this).attr('data-product-id');
					
					let pageUrl = $(this).attr('data-product-url');

					/*console.log('variantID =' + variantID);
					console.log('variantTitle =' + variantTitle);
					console.log('variantPrice =' + variantPrice);
					console.log('productID =' + productID);
					console.log('pageUrl =' + pageUrl);*/

					let wishlistApiData = {
							"epi": variantID,
							"dt": productTitle,
							"du": pageUrl,
							"empi": productID,
							//"iu" : imageUrl,
							"pr": variantPrice,
							"variants": [{[variantTitle]: variantID}]
						}
			
				

				
        
        // add wishlist object for addToWishList() function to the localStorage
        function pushItemToLocalStorage(wishlistApiData) {
		      localStorage.setItem('swym-login-wishlist', JSON.stringify(wishlistApiData));          
        }

        pushItemToLocalStorage(wishlistApiData);



        setTimeout(() => {
            let localStorageWishlist = JSON.parse(localStorage.getItem('swym-login-wishlist')) || {};
            if (jQuery.isEmptyObject(localStorageWishlist) == false) {
              window.location.replace("/account/login");              
            } else {              
              pushItemToLocalStorage(wishlistApiData);
            }
        }, 200, wishlistApiData)
		
			});
		
}
wishlistCollectionPage();

 document.addEventListener("swym:collections-loaded", function(event) {
    wishlistCollectionPage();
	});